export default __webpack_public_path__ + "static/b_helles_02-c65deaaf5759d9d76095ee650a0d8a28.png";